module.exports = __webpack_public_path__ + "img/1684205719716-image.jpg.ca4fcbdc.webp";